export default class Parte {
    constructor({
        cliente_id,
        cliente,
        user_id = 6, // Por defecto, asignamos el usuario General (id -> 6)
        comercial_id = 25, // Por defecto, asignamos el comercial genérico "Comercial Interno" (id -> 25)
        concepto,
        realizar = 'Tareas varias',
        fecha,
        inicio = '09:00:00',
        fechaVto,
        delegacion_id,
        fidelizar = 0,
        estadoParte_id = 1,
    }){
        this.cliente_id = cliente_id;
        this.cliente = cliente;
        this.user_id = user_id;
        this.comercial_id = comercial_id;
        this.concepto = concepto;
        this.realizar = realizar;
        if(fecha){
            this.fecha = new Date(fecha).toLocaleDateString("en-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        }else{
            this.fecha = new Date().toLocaleDateString("en-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        }
        this.inicio = inicio;
        if(fechaVto){
            this.fechaVto = new Date(fechaVto).toLocaleDateString("en-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        }else{
            this.fechaVto = this.fecha;
        }
        this.delegacion_id = delegacion_id;
        this.fidelizar = fidelizar;
        this.estadoParte_id = estadoParte_id;
    }
}